import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import BaseField from '../BaseField/BaseField';
import styles from './DatePickerField.module.sass';
import "react-datepicker/dist/react-datepicker.css";
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment-timezone';

const DatePickerField = ({
    value, onChange,
    ...props
}: Props) => {
    const initialState: any = {
        startDate: null,
        endDate: null
    }
    const [data, setData] = useState(initialState);
    const [state, setState] = useState({
        isFocused: false
    });

    const handleChange = (dates: any) => {
        const [start, end] = dates;

        setData({
            startDate: start,
            endDate: end
        });
    };

    useEffect(() => {
        if (state.isFocused) return;
        propagateChange();
    }, [state.isFocused]);

    useEffect(() => {
        if (value.length === 0) {
            setData(initialState);

            return;
        };
        const dates = value?.[0].split(',');

        console.log({
            startDate: moment(dates?.[0]).toDate(),
            endDate: moment(dates?.[1]).toDate()            
        });
        setData({
            startDate: moment(dates?.[0]).toDate(),
            endDate: moment(dates?.[1]).toDate()
        });
    }, [value]);

    const propagateChange = () => {
        if (!data.startDate) {
            onChange([]);
            return;
        }
        const startDate = data.startDate;

        let endDate = data.endDate;
        if (!endDate) endDate = new Date();

        setData({
            ...data,
            startDate,
            endDate
        });
        onChange([moment(startDate), moment(endDate)]);
    }

    const handleClear = () => {
        onChange([moment(data.startDate), moment(data.endDate)]);
        setData(initialState);
    };
    
    const handleFocus = (value) => setState((state) => ({
        ...state,
        isFocused: value
    }));

    return <BaseField
        iconBefore={<FontAwesomeIcon icon={faCalendarDays} />}
        iconAfter={
            data.startDate && <FontAwesomeIcon
            icon={faXmark}
            onClick={handleClear}
            style={{ cursor: 'pointer' }}
        />}
        onFocus={handleFocus}
    >
        <div className={styles['datepickerfield']}>
            <DatePicker
                className={styles['datepickerfield__component']}
                onChange={handleChange}
                placeholderText="Klik hier om een datum range te selecteren"
                dateFormat="dd/MM/yyyy"
                startDate={data.startDate}
                endDate={data.endDate}
                showPopperArrow={false}
                dropdownMode="select"
                selectsRange
                showMonthDropdown
                showYearDropdown
            />
        </div>
    </BaseField>;
}

interface Props {
    value: any
    onChange: any
}

export default DatePickerField;